import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import {FeatureFlagService} from '../services/feature-flag.service';

@Directive({
  selector: '[appFeatureFlag]',
  standalone: true,
})
export class FeatureFlagDirective implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private featureFlagService = inject(FeatureFlagService);

  @Input() appFeatureFlag: string;
  @Input('appFeatureFlagInverseLogic') inverseLogic: boolean = false;
  isEnabled = false;
  ngOnInit() {
    if (!this.appFeatureFlag) {
      throw new Error('*featureFlag must be given a parameters for flagKey');
    }

    this.featureFlagService.get(this.appFeatureFlag).subscribe((flagValue) => {
      if (
        (flagValue === 'on' && !this.inverseLogic) ||
        (flagValue !== 'on' && this.inverseLogic)
      ) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isEnabled = true;
      } else {
        this.viewContainer.clear();
        this.isEnabled = false;
      }
    });
  }
}
